import { auth } from "./helpers";
import type { AuthContext } from "./types";

/** Read permission codes from the persisted session, if any. */
export function getSessionPermissions(): string[] {
  return auth.getSession()?.activeContext.permissions ?? [];
}

/** Active context from the persisted session. */
export function getActiveContext(): AuthContext | null {
  return auth.getSession()?.activeContext ?? null;
}

/** Whether the session includes a specific permission code. */
export function hasPermission(permission: string, permissions = getSessionPermissions()): boolean {
  return permissions.includes(permission);
}

/** Whether the session includes at least one of the given permission codes. */
export function hasAnyPermission(
  required: string[],
  permissions = getSessionPermissions(),
): boolean {
  return required.some((p) => permissions.includes(p));
}
